<template>
  <Popover
    class="h-full w-full"
    hide-on-mobile
    no-padding
    custom-action-handler
    :model-value="desktopOpen"
    @update:modelValue="$emit('desktopOpenChange', $event)"
  >
    <template #action>
      <div class="flex items-center h-full">
        <TextField
          :model-value="eventLocationCaption"
          :icon="SearchIcon"
          readonly
          class="location-input"
          @click="$emit('toggleOpen', $event)"
        />
      </div>
    </template>

    <div style="width: 400px">
      <LocationFilters
        class="p-6 pb-4"
        :form="form"
        :tags="tags"
        :is-mobile="isMobile"
        @locationChange="$emit('locationChange', $event)"
        @eventTypeChange="$emit('eventTypeChange', $event)"
      />

      <ActionsWrapper class="justify-end flex">
        <BaseButton
          color="green"
          :is-loading="isLoading"
          @click="$emit('submit', $event)"
        >
          Search
        </BaseButton>
      </ActionsWrapper>
    </div>
  </Popover>
</template>

<script>

import SearchIcon from '@tagvenue/icons/24/line/general/search-md.svg';

import ActionsWrapper from '@/components/Ui/ActionsWrapper.vue';
import BaseButton from '@/components/Ui/Buttons/BaseButton.vue';
import TextField from '@/components/Ui/Forms/TextField.vue';
import Popover from '@/components/Ui/Popover.vue';

import LocationFilters from './Location/LocationFilters.vue';

export default {
  name: 'TagLocationFiltersSmall',
  components: { BaseButton, ActionsWrapper, LocationFilters, TextField, Popover },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    isMobile: {
      type: Boolean,
      required: true,
    },
    eventTypeLabel: {
      type: String,
      required: true,
    },
    desktopOpen: {
      type: Boolean,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
    tags: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      SearchIcon,
    };
  },
  computed: {
    eventLocationCaption() {
      const location = this.form.location;

      let caption = this.eventTypeLabel;
      if (location?.length) {
        caption += ` • ${location}`;
      }
      return caption;
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@sass/design-system/variables" as ds-variables;

.location-input {
  width: 100%;

  :deep(input) {
    border: none;
    background-color: ds-variables.$grey-200;
    font-size: 12px;
  }
}

</style>
